import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/sale-regions', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/sale-regions/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, saleRegionData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/sale-regions', saleRegionData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, saleRegionData) {
      return new Promise((resolve, reject) => {
        const url = `/sale-regions/${saleRegionData.id}`
        axios
          .put(url, saleRegionData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/sale-regions/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
